import { aiSystemDescriptor } from './ai-system.js';
import { documentDescriptor } from './document.js';
/** coreBOS standard modules the harvest does not cover (hand-written, no installer needed). */
export const crmDescriptors = [documentDescriptor];
export const baseDescriptors = [aiSystemDescriptor, ...crmDescriptors];
